'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoForkRepo = function IoForkRepo(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm32.5 6.3v5h-3.7v3.7h-5v-3.7h-3.8v-5h3.8v-3.8h5v3.8h3.7z m-8.7 12.5h5v0.3c0 3.4-0.6 5.5-3 7.5-1.8 1.4-4 1.5-5.9 1.7-0.7 0.1-1.4 0.1-2 0.2-0.5 0.1-1 0.4-1.6 0.8 0.7 0.9 1.2 2 1.2 3.2 0 2.7-2.3 5-5 5s-5-2.3-5-5c0-1.9 1-3.4 2.5-4.3v-16.4c-1.5-0.9-2.5-2.4-2.5-4.3 0-2.7 2.3-5 5-5s5 2.3 5 5c0 1.9-1 3.4-2.5 4.3v12.5c0.6-0.3 1.4-0.5 2.1-0.7 0.9-0.2 1.7-0.2 2.4-0.2 1.4-0.1 2.6-0.3 3.2-0.7 0.7-0.7 1.1-0.9 1.1-3.9z m-11.3-13.8c-1.4 0-2.5 1.1-2.5 2.5s1.1 2.5 2.5 2.5 2.5-1.1 2.5-2.5-1.1-2.5-2.5-2.5z m0 30c1.4 0 2.5-1.1 2.5-2.5s-1.1-2.5-2.5-2.5-2.5 1.1-2.5 2.5 1.1 2.5 2.5 2.5z' })
        )
    );
};

exports.default = IoForkRepo;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/fork-repo.js
// module id = 2266
// module chunks = 0